import { DisplayMode } from '@/stores/filterSidebarStore';

import { FilterHierarchyFieldsGroupOption } from '../../PlpFilters.type';

export const getFilteredOptions = (options: FilterHierarchyFieldsGroupOption[], displayMode: DisplayMode) => {
  if (displayMode === 'popular') {
    return options.slice(0, 8);
  }

  return options.filter((option) => option.children!.length > 1).sort((a, b) => a.value.localeCompare(b.value));
};
